import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './langs/en.js'
import ja from './langs/ja.js'
import zh from './langs/zh-cn.js'
import locale from 'element-ui/lib/locale'

Vue.use(VueI18n)

const messages = {
  en: en,
  ja: ja,
  zh: zh
}

const i18n = new VueI18n({
  locale: 'ja', // 设置地区
  messages, // 设置地区信息
})
locale.i18n((key, value) => i18n.t(key, value))

export default i18n